(function() {

  // ФІКС ДЛЯ СЕКЦІЇ БЛОГІВ 
  document.addEventListener('DOMContentLoaded', function() {
    const styleFix = document.createElement('style');
    styleFix.innerHTML = `
      .blog-section { 
        width: 100% !important; 
        max-width: 100% !important; 
        overflow-x: hidden !important; 
      }

      .blog-section .grid-outer {
        padding-left: 3vw !important; /* ПОСТІЙНИЙ ВІДСТУП ЗЛІВА */
        padding-right: 0 !important;
        margin: 0 !important;
        overflow: visible !important;
      }

      .blog-section .blog-listing {
        display: flex !important;
        flex-wrap: nowrap !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        
        gap: 20px !important; 
        
        padding-top: 10px !important;
        padding-bottom: 50px !important; /* Місце знизу для тіні */
        padding-right: 5vw !important; /* Щоб останній блог не бився об правий край в кінці */
        
        scroll-snap-type: x mandatory;
        scrollbar-width: none !important; 
        -ms-overflow-style: none !important;
        transform: none !important;
      }

      .blog-section .blog-listing::-webkit-scrollbar { display: none !important; }
      .blog-section .slider-progress, 
      .blog-section .flickity-page-dots,
      .blog-section .progress-bar { display: none !important; }

      .blog-section .article.grid-item {
        max-width: none !important;
        width: auto !important;
        margin: 0 !important; 
        scroll-snap-align: start;
        background: #fff;
        position: relative !important;
        left: auto !important; 
        top: auto !important;
        border-radius: 0 !important; 
        flex-shrink: 0 !important;
        transition: none !important; 
      }

      /* === 5. ТУТ НАЛАШТОВУЄТЬСЯ РОЗМІР (ШИРИНА) БЛОГІВ === */
      @media (max-width: 767px) {
        .blog-section .article.grid-item { flex: 0 0 75vw !important; } 
      }
      @media (min-width: 768px) and (max-width: 989px) {
        .blog-section .article.grid-item { flex: 0 0 40vw !important; } 
      }
      @media (min-width: 990px) {
        .blog-section .article.grid-item { flex: 0 0 22vw !important; } 
      }

      /* 6. Ефект наведення (ТІЛЬКИ на зображення) */
      .blog-section .article.grid-item img {
        transition: transform 0.3s ease !important;
        display: block !important;
      }
      .blog-section .article.grid-item:hover img {
        transform: scale(1.02) !important; 
      }

      /* Квадратні зображення */
      .blog-section .article__image {
        border-radius: 0 !important; 
        overflow: hidden !important; 
        display: block !important;
      }

      .blog-section .article__image__outer {
        transition: box-shadow 0.3s ease !important;
        display: block !important;
      }
      .blog-section .article.grid-item:hover .article__image__outer {
        box-shadow: 0 10px 25px rgba(0,0,0,0.12) !important; 
      }
    `;
    document.head.appendChild(styleFix);
  });

  // ============================================================
  // КАСТОМІЗАЦІЯ ДЛЯ ОПЦІЙ NAME SIGN (Globo Product Options)
  // ============================================================
  (function() {

    // Твої налаштування: тут ти можеш змінювати всі розміри і кількості
    const CONFIG_NAME_SIGN = {
      // 1. Налаштування кольорів
      colorsPerRowDesktop: 9, 
      colorSizeDesktop: '42px', // Розмір кружечка кольору на комп'ютері
      
      colorsPerRowMobile: 6,  
      colorSizeMobile: '35px',  // Розмір кружечка кольору на телефоні

      // 2. Налаштування шрифтів
      fontWidthDesktop: '130px',
      fontHeightDesktop: '65px',
      
      fontWidthMobile: '100px',
      fontHeightMobile: '50px'
    };

    // Функція для впровадження жорсткого CSS
    function injectNameSignStyles() {
      if (document.getElementById('name-sign-js-styles')) return;
      
      const styleEl = document.createElement('style');
      styleEl.id = 'name-sign-js-styles';
      styleEl.innerHTML = `
        /* =================================================== */
        /* 1. БАЗОВІ ФІКСИ ДЛЯ ШРИФТІВ                         */
        /* =================================================== */
        .name-sign-fonts .gpo-ov-wrapper {
            display: flex !important;
            flex-wrap: wrap !important;
            gap: 12px !important; 
        }
        .name-sign-fonts .gpo-swatches {
            margin: 0 !important; 
            flex: 0 0 auto !important; 
            overflow: visible !important; 
        }
        .name-sign-fonts .gpo-swatches label {
            width: 100% !important; 
            height: 100% !important;
            display: block !important;
            padding: 0 !important;
        }
        .name-sign-fonts .gpo-swatch__inner,
        .name-sign-fonts .swatch-image {
            width: 100% !important;
            height: 100% !important;
            object-fit: contain !important;
        }

        /* =================================================== */
        /* 3. НАЛАШТУВАННЯ ДЛЯ ДЕСКТОПУ                        */
        /* =================================================== */
        @media (min-width: 769px) {
          
          /* --- ШРИФТИ --- */
          .name-sign-fonts .gpo-swatches {
            width: ${CONFIG_NAME_SIGN.fontWidthDesktop} !important;
            height: ${CONFIG_NAME_SIGN.fontHeightDesktop} !important;
          }

          /* --- КОЛЬОРИ: ПЕРЕТВОРЮЄМО СЛАЙДЕР НА СІТКУ --- */
          .name-sign-colors .swiper {
            overflow: visible !important; 
          }
          .name-sign-colors .swiper-wrapper {
            flex-wrap: wrap !important; /* Дозволяємо перенос на новий рядок */
            transform: none !important; /* Вбиваємо ефект прокрутки слайдера */
            height: auto !important;
          }
          .name-sign-colors .swiper-slide {
            /* Розраховуємо ширину для заданої кількості в ряд */
            width: calc(100% / ${CONFIG_NAME_SIGN.colorsPerRowDesktop} - 10px) !important;
            margin: 0 10px 10px 0 !important;
            flex: 0 0 auto !important;
          }
          
          /* Задаємо розмір самого кружечка кольору */
          .name-sign-colors .swatch-top {
            width: ${CONFIG_NAME_SIGN.colorSizeDesktop} !important;
            height: ${CONFIG_NAME_SIGN.colorSizeDesktop} !important;
          }

          /* ХОВАЄМО ЗАЙВЕ: Стрілочки слайдера та іконку "i" */
          .name-sign-colors .gpo-swiper-navigation,
          .name-sign-colors .label-tooltip {
            display: none !important;
          }
        }

        /* =================================================== */
        /* 4. НАЛАШТУВАННЯ ДЛЯ МОБІЛЬНОГО (ЕКРАНИ ДО 768px)    */
        /* =================================================== */
        @media (max-width: 768px) {
          
          /* --- ШРИФТИ --- */
          .name-sign-fonts .gpo-swatches {
            width: ${CONFIG_NAME_SIGN.fontWidthMobile} !important;
            height: ${CONFIG_NAME_SIGN.fontHeightMobile} !important;
          }
          .name-sign-fonts .gpo-ov-wrapper {
            gap: 8px !important; 
          }

          /* --- КОЛЬОРИ --- */
          /* На телефоні залишається слайдер, міняємо лише розмір кружечка */
          .name-sign-colors .swatch-top {
            width: ${CONFIG_NAME_SIGN.colorSizeMobile} !important;
            height: ${CONFIG_NAME_SIGN.colorSizeMobile} !important;
          }
        }
      `;
      document.head.appendChild(styleEl);
    }

    // Функція для оновлення Swiper слайдерів з кольорами (потрібно для мобільного)
    function updateColorSliders() {
      const isMobile = window.innerWidth <= 768;
      const targetSwatchesPerRow = isMobile ? CONFIG_NAME_SIGN.colorsPerRowMobile : CONFIG_NAME_SIGN.colorsPerRowDesktop;

      const colorSliders = document.querySelectorAll('.name-sign-colors .swiper');

      colorSliders.forEach(function(sliderEl) {
        sliderEl.setAttribute('data-swatches-per-row', targetSwatchesPerRow);
        if (sliderEl.swiper) {
          sliderEl.swiper.params.slidesPerView = targetSwatchesPerRow;
          sliderEl.swiper.update(); 
        }
      });
    }

    // Головний ініціалізатор
    function initNameSignCustomizer() {
      injectNameSignStyles();
      updateColorSliders();
    }

    // Запускаємо логіку при зміні розміру вікна 
    window.addEventListener('resize', function() {
      updateColorSliders();
    });

    // Чекаємо завантаження Swiper (Кольори)
    let checkAttempts = 0;
    const globoInitChecker = setInterval(function() {
      const colorSliders = document.querySelectorAll('.name-sign-colors .swiper');
      if (colorSliders.length > 0 && colorSliders[0].swiper) {
        initNameSignCustomizer();
        clearInterval(globoInitChecker); 
      }
      checkAttempts++;
      if (checkAttempts > 100) clearInterval(globoInitChecker);
    }, 100);

    // Чекаємо завантаження Шрифтів (вони можуть з'явитись раніше за Swiper)
    const fontChecker = setInterval(function() {
      if (document.querySelector('.name-sign-fonts')) {
          injectNameSignStyles();
          clearInterval(fontChecker);
      }
    }, 100);

  })();
})();

  /* ===== BP опції Globo: підпис вибраного під рядом Image / Color Swatch =====
    Показує "Selected: ..." — усі обрані через кому (для кольорів ще й кольоровий
    квадратик). Працює і для одиночного вибору, і для мультивибору, і коли
    перевибираєш. Вимкнути: BP_CAPTION_ENABLED = false.
    Не чіпає форми з Name Sign. Окремий блок, від решти коду не залежить. */
  (function () {
    var BP_CAPTION_ENABLED = true;
    var BP_CAPTION_LABEL = 'Selected';
    if (!BP_CAPTION_ENABLED) return;

    var SWATCHES = '.gpo-swatches:not(.buttons)'; // Image + Color Swatch, без кнопок Yes/No

      function updateCaption(element) {
      if (!element) return;
      var checked = element.querySelectorAll(SWATCHES + ' input:checked');
      var seen = {};
      var items = Array.prototype.filter.call(checked, function (i) {
        var key = (i.name || '') + '|' + i.value;
        if (seen[key]) return false; // Swiper може дублювати слайди
        seen[key] = true;
        return true;
      });
      var sig = items.map(function (i) { return i.id || i.value; }).join('|');
      var caption = element.querySelector('.bp-gpo-caption');
      if (element.__bpSig === sig && (caption || !items.length)) return; // нічого не змінилось
      element.__bpSig = sig;

      if (!items.length) {
        if (caption) caption.remove();
        return;
      }
      if (!caption) {
        // Беремо прямого нащадка .gpo-element, де лежать перемикачі (ряд або слайдер)
        var anchor = element.querySelector(SWATCHES + ' input');
        while (anchor && anchor.parentElement !== element) anchor = anchor.parentElement;
        if (!anchor) return;
        caption = document.createElement('div');
        caption.className = 'bp-gpo-caption';
        caption.setAttribute('aria-live', 'polite');
        anchor.insertAdjacentElement('afterend', caption);
      }
      caption.textContent = BP_CAPTION_LABEL + ': ';
      items.forEach(function (i, idx) {
        if (idx) caption.appendChild(document.createTextNode(', '));
        var color = i.getAttribute('data-color1');
        if (color) {
          var chip = document.createElement('span');
          chip.className = 'bp-gpo-chip';
          chip.style.backgroundColor = color;
          caption.appendChild(chip);
        }
        caption.appendChild(document.createTextNode(i.value));
      });
    }

  function refreshAll() {
    document.querySelectorAll('.gpo-app .gpo-element').forEach(function (el) {
      if (el.querySelector(SWATCHES)) updateCaption(el);
    });
  }

  var timer;
  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refreshAll, 60);
  }

  // Слухаємо у фазі capture, щоб Globo не міг "з'їсти" подію
  ['click', 'change', 'input'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target && e.target.closest && e.target.closest('.gpo-app')) scheduleRefresh();
    }, true);
  });

  // Страховка: Globo сам вмикає/вимикає опції (ліміт вибору, умовна логіка)
  function observe() {
    if (!window.MutationObserver) return;
    document.querySelectorAll('.gpo-app').forEach(function (app) {
      if (app.__bpObserved) return;
      app.__bpObserved = true;
      new MutationObserver(scheduleRefresh).observe(app, {
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'checked', 'class']
      });
    });
  }

  // Форма Globo малюється після завантаження сторінки
  document.addEventListener('gpoRenderCompleted', function () {
    observe();
    scheduleRefresh();
  });

  function init() {
    observe();
    refreshAll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===== Галерея товару (десктоп): підказка, що мініатюри можна гортати =====
   Ставить на .product__thumbs класи bp-can-up / bp-can-down, коли всередині
   є що гортати вгору/вниз; градієнт зі стрілкою малює CSS. */
(function () {
  function bind(thumbs) {
    var holder = thumbs.querySelector('.product__thumbs__holder');
    if (!holder || holder.getAttribute('data-bp-hint')) return;
    holder.setAttribute('data-bp-hint', '1');
    function update() {
      var max = holder.scrollHeight - holder.clientHeight;
      thumbs.classList.toggle('bp-can-up', holder.scrollTop > 2);
      thumbs.classList.toggle('bp-can-down', max > 2 && holder.scrollTop < max - 2);
    }
    holder.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(holder);
    update();
  }
    function init() {
    // працює лише коли в темі обрано мініатюри зліва
    if (!document.querySelector('.product__wrapper--thumbnails-left')) return;
    document.querySelectorAll('.product__thumbs').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();

/* Ховає плаваючу кнопку чату Support, поки відкритий drawer-кошик */
(function () {
  function findChatHost() {
    return Array.from(document.querySelectorAll('body *')).find(function (el) {
      return el.shadowRoot && el.shadowRoot.querySelector('#shopify-element-wrapper');
    });
  }
  function isOpen(drawer) {
    return Array.from(drawer.classList).some(function (c) {
      return /open|active|visible/i.test(c);
    });
  }
  function sync() {
    var drawer = document.querySelector('cart-drawer');
    var host = findChatHost();
    if (!drawer || !host) return;
    host.style.display = isOpen(drawer) ? 'none' : '';
  }
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    var tries = 0;
    var timer = setInterval(function () {
      sync();
      if (++tries > 20) clearInterval(timer);
    }, 500);
  });
})();

/* Cart drawer: стрілки для слайдера апселу */
(function () {
  var ICON_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  function makeButton(widget, dir) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', dir < 0 ? 'Previous' : 'Next');
    btn.innerHTML = dir < 0 ? ICON_L : ICON_R;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var track = widget.querySelector('[data-upsell-products]');
      if (track) track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    });
    return btn;
  }

  function ensureNav() {
    var widget = document.querySelector('cart-drawer [data-upsell-widget]');
    if (!widget || widget.querySelector('.bp-upsell-nav')) return;
    var nav = document.createElement('div');
    nav.className = 'bp-upsell-nav';
    nav.appendChild(makeButton(widget, -1));
    nav.appendChild(makeButton(widget, 1));
    widget.appendChild(nav);
  }

  document.addEventListener('DOMContentLoaded', function () {
    ensureNav();
    var target = document.querySelector('cart-drawer') || document.body;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; ensureNav(); });
    }).observe(target, { childList: true, subtree: true });
  });
})();

/* Cart drawer: апсел завжди відкритий (його не можна згорнути вручну) */
(function () {
  function keepUpsellOpen() {
    var widget = document.querySelector('cart-drawer [data-upsell-widget]');
    if (!widget || widget.classList.contains('is-hidden')) return;
    var body = widget.querySelector('[data-collapsible-body]');
    if (!widget.hasAttribute('open')) widget.setAttribute('open', '');
    if (body && body.style.height !== 'auto') body.style.height = 'auto';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; keepUpsellOpen(); });
    }).observe(drawer, { attributes: true, attributeFilter: ['open', 'style', 'class'], subtree: true });
  });
})();